import { DL_APP_GLASS_DIALOGS, DL_APP_GLASS_HELPER, DL_APP_GLASS_PLAYER } from "mlng";


export interface GlassLayerElement { name: string, blocking: boolean, level: number };

export let APP_GLASS_LAYERS: GlassLayerElement[] = [
    { name: DL_APP_GLASS_PLAYER, blocking: false, level: 300 },
    { name: DL_APP_GLASS_HELPER, blocking: false, level: 320 },
    { name: DL_APP_GLASS_DIALOGS, blocking: true, level: 340 }
];